import React, {useState, useEffect} from 'react'
import {actionsType} from 'config/constants'
import Drawer from 'components/Drawers/Drawer'
import PaymentMethod from './PaymentMethod'
import PubSub from 'services/PubSub'
import style from './style.scss'//NOSONAR

let actions = [];

const DrawerPaymentMethod = () => {
    const [payload, setPayload] = useState(null);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.PAYMENT_METHOD_OPEN, open));

        return function cleanup () {
            actions.map(token => PubSub.unregister(token));
        }
    },[]);

    const open = (payload) => {
        setPayload(payload.value);
        
    }

    return (
        <Drawer
            customClass="drawer-payment-method"
            actionOpen={actionsType.DRAWER.PAYMENT_METHOD_OPEN}
            actionClose={actionsType.DRAWER.PAYMENT_METHOD_CLOSE}>
            <PaymentMethod payload={payload} />
        </Drawer>
    )
}

export default DrawerPaymentMethod
